export const ROLE_GM_ADMIN = 'GM_ADMIN';
export const ROLE_MSS_ADMIN = 'MSS_ADMIN';
export const ROLE_MSS_USER = 'MSS_USER';
export const ROLE_MSS_RECRUITER = 'MSS_RECRUITER';
export const ROLE_NON_MSS_USER = 'NON_MSS_USER';
